{
  "$id": "module://sandbox",
  "$schema": "wealthlane://schemas/domain",
  "title": "Sandbox",
  "description": "Sandbox CRU, share, change-status, and load-to-main field catalog",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "name": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "noBlank": true
    },
    "sandboxType": {
      "type": "string",
      "title": "Create Type",
      "widget": "select",
      "format": "sandbox-create-type",
      "noBlank": true
    },
    "sandboxTypeLabel": {
      "type": "string",
      "title": "Create Type Label",
      "widget": "hidden"
    },
    "fromTenantId": {
      "type": "string",
      "title": "From",
      "widget": "select",
      "format": "sandbox-tenant-id",
      "noBlank": true
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "noBlank": true,
      "maxLength": 2000,
      "adapterProps": { "rows": 5 }
    },
    "visibility": {
      "type": "string",
      "title": "Sandbox Type",
      "widget": "select",
      "format": "sandbox-visibility",
      "noBlank": true
    },
    "copyRoleOverrides": {
      "type": "boolean",
      "title": "Copy role overrides",
      "widget": "hidden",
      "default": false
    },
    "copyRoleOverridesBanner": {
      "type": "string",
      "title": "",
      "widget": "info-banner",
      "adapterProps": {
        "watchField": "copyRoleOverrides",
        "variant": "info",
        "semanticId": "copyRoleOverridesInfoBanner",
        "messageWhenFalse": {
          "lead": "Copy role overrides: No.",
          "body": "Roles and user role assignments will not be copied. The new sandbox will rely on company-level roles only."
        },
        "messageWhenTrue": {
          "lead": "Copy role overrides: Yes.",
          "body": "Roles and user role assignments from the source environment will be copied into the new sandbox."
        }
      }
    },
    "sandboxId": {
      "type": "array",
      "title": "Select Users",
      "widget": "select",
      "isMulti": true,
      "minItems": 1,
      "items": { "type": "string" },
      "adapterProps": {
        "placeholder": "Search and select users..."
      }
    },
    "sandboxRecordId": {
      "type": "string",
      "title": "",
      "widget": "hidden"
    },
    "lockState": {
      "type": "string",
      "title": "Select Status",
      "widget": "select",
      "noBlank": true,
      "adapterProps": {
        "placeholder": "Select status..."
      }
    },
    "lockStateLabel": {
      "type": "string",
      "title": "",
      "widget": "hidden"
    },
    "lockInfoBanner": {
      "type": "string",
      "title": "",
      "widget": "info-banner",
      "adapterProps": {
        "watchField": "showLockInfo",
        "variant": "info",
        "semanticId": "lockInfoBox",
        "messageWhenTrue": {
          "lead": "Information:",
          "body": "When this instance is locked, the data will be preserved, you will not be able to switch to this instance and make changes to the data. You can however create a copy of this locked instance and switch to the copy for full access. You can also unlock this instance at a later time if you wish to."
        }
      }
    },
    "showLockInfo": {
      "type": "boolean",
      "title": "",
      "widget": "hidden",
      "default": false
    },
    "lockedOptionValue": {
      "type": "string",
      "title": "",
      "widget": "hidden"
    },
    "tenantId": {
      "type": "string",
      "title": "",
      "widget": "hidden"
    },
    "sandboxName": {
      "type": "string",
      "title": "",
      "widget": "hidden"
    },
    "sandboxTenantId": {
      "type": "string",
      "title": "Instance",
      "widget": "select",
      "format": "production-instance-id",
      "noBlank": true
    },
    "remarks": {
      "type": "string",
      "title": "Remarks",
      "widget": "textarea",
      "noBlank": true,
      "maxLength": 2000,
      "adapterProps": { "rows": 5 }
    },
    "keepRoleOverrides": {
      "type": "boolean",
      "title": "Keep role overrides",
      "widget": "checkbox",
      "default": true,
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "keepRoleOverridesBanner": {
      "type": "string",
      "title": "",
      "widget": "info-banner",
      "adapterProps": {
        "watchField": "keepRoleOverrides",
        "variant": "info",
        "semanticId": "keepRoleOverridesInfoBanner",
        "messageWhenTrue": {
          "lead": "Keep role overrides: Yes.",
          "body": "Roles and user role assignments from the sandbox will be kept when loading to main."
        },
        "messageWhenFalse": {
          "lead": "Keep role overrides: No.",
          "body": "Roles and user role assignments from the sandbox will not be kept. Main will continue to use company-level roles only."
        }
      }
    }
  }
}
